var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{attrs:{"id":"legendsContainer"}}),_c('LineChart',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":"keyword-rankings-chart","height":_vm.chartHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }